'use client';

import cn from 'classnames';

import { withClientOnly } from '@/helpers/ssr/ClientOnly';

import BACKGROUND_IMAGE_GRADIENT_CONFIG from './constants';
import { useGetImageOfShownSailing } from './hooks';
import BackgroundImageGradient from './Image';

import styles from './BackgroundImageGradient.module.scss';

type Props = { className?: string; src?: string } & Partial<
  React.ComponentPropsWithoutRef<typeof BackgroundImageGradient>
>;

const BackgroundImageGradientVariative = ({ className, src, ...props }: Props) => {
  const shownSailingSrc = useGetImageOfShownSailing(src);

  return (
    <BackgroundImageGradient
      className={cn(styles.pageWrapper, className)}
      gradientDirection="top"
      src={shownSailingSrc}
      {...BACKGROUND_IMAGE_GRADIENT_CONFIG.topper}
      {...props}
    />
  );
};

export default withClientOnly(BackgroundImageGradientVariative);
